import i18next from 'i18next';

export function formatKbytes(kbytes) {
  let iterCount = 0;
  let res = parseInt(kbytes);

  while (res > 100 && iterCount < 2) {
    res /= 1024;
    iterCount++;
  }

  let r = i18next.t('cabinet.misc.kb');

  if (iterCount > 0) r = i18next.t('cabinet.misc.mb');
  if (iterCount > 1) r = i18next.t('cabinet.misc.gb');

  return `${res.toFixed(1)} ${r}`;
}
